var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"content-h100 overflow-auto p-3",attrs:{"fluid":""}},[_vm._v(" Super Dashboard "+_vm._s(_vm.loggedName)+" "+_vm._s(_vm.account)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }